export const EMPLOYMENT_STATUS_LIST = [
  {
    description: 'Employed',
    code: 'EMPLOYED',
    id: 1,
  },
  {
    description: 'Unemployed',
    code: 'UNEMPLOYED',
    id: 3,
  },
  {
    description: 'Retired',
    code: 'RETIRED',
    id: 4,
  },
  {
    description: 'Student',
    code: 'STUDENT',
    id: 6,
  },
];
